export const shopCategories = [
  { id: 'all', label: '全部' },
  { id: 'stationery', label: '文具/钢笔' },
  { id: 'paper', label: '纸张/本册' },
  { id: 'books', label: '教辅书籍' },
  { id: 'clothing', label: '学生服装' },
  { id: 'digital', label: '学习设备' },
  { id: 'desk', label: '学习桌椅' },
];

export const shopProducts = [
  // ── PENS & STATIONERY ──
  {
    id: '1',
    name: '晨光多功能学生文具套装（含钢笔+铅笔+尺子+橡皮）',
    category: 'stationery',
    price: 39.9,
    originalPrice: 59.9,
    sales: 12340,
    rating: 4.9,
    merchant: '晨光文具旗舰店',
    stock: 500,
    weight: 0.3,
    image: 'https://public.readdy.ai/ai/img_res/3f2d79ad9bdb06f8a6e41e58da1b30f1.jpg',
  },
  {
    id: '2',
    name: '英雄钢笔礼盒套装 学生练字专用金属笔尖',
    category: 'stationery',
    price: 68.0,
    originalPrice: 99.0,
    sales: 7820,
    rating: 4.9,
    merchant: '英雄钢笔官方旗舰店',
    stock: 300,
    weight: 0.2,
    image: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20Hero%20brand%20fountain%20pen%20gift%20set%20in%20luxury%20wooden%20box%2C%20gold%20nib%2C%20clean%20white%20background%2C%20premium%20product%20photography%2C%20classic%20black%20pen%20design&width=300&height=300&seq=p009&orientation=squarish',
  },
  {
    id: '11',
    name: '百乐钢笔 PILOT 学生书法练字专用 EF极细笔尖',
    category: 'stationery',
    price: 88.0,
    originalPrice: 128.0,
    sales: 5430,
    rating: 4.9,
    merchant: '百乐文具官方店',
    stock: 420,
    weight: 0.15,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Pilot%20fountain%20pen%20for%20students%2C%20extra%20fine%20nib%2C%20sleek%20black%20and%20silver%20design%2C%20clean%20white%20background%2C%20premium%20stationery%20product%20photography%2C%20elegant%20minimalist%20style&width=300&height=300&seq=p011&orientation=squarish',
  },
  {
    id: '12',
    name: '派克钢笔 PARKER 商务礼品套装 墨水笔礼盒',
    category: 'stationery',
    price: 198.0,
    originalPrice: 298.0,
    sales: 3210,
    rating: 4.8,
    merchant: '派克官方旗舰店',
    stock: 180,
    weight: 0.25,
    image: 'https://readdy.ai/api/search-image?query=Parker%20fountain%20pen%20luxury%20gift%20set%20in%20elegant%20black%20box%2C%20silver%20trim%2C%20premium%20business%20pen%2C%20clean%20white%20background%2C%20high-end%20stationery%20product%20photography&width=300&height=300&seq=p012&orientation=squarish',
  },
  {
    id: '13',
    name: '晨光中性笔签字笔 0.5mm 黑色 20支装',
    category: 'stationery',
    price: 15.9,
    originalPrice: 22.0,
    sales: 89320,
    rating: 5.0,
    merchant: '晨光文具旗舰店',
    stock: 5000,
    weight: 0.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Chenguang%20gel%20pens%20black%20ink%200.5mm%20pack%20of%2020%2C%20clean%20white%20background%2C%20student%20stationery%20product%20photography%2C%20simple%20packaging%2C%20multiple%20pens%20arranged%20neatly&width=300&height=300&seq=p013&orientation=squarish',
  },
  {
    id: '14',
    name: '斑马牌彩色荧光笔套装 10色 学生标注划重点',
    category: 'stationery',
    price: 29.9,
    originalPrice: 45.0,
    sales: 23450,
    rating: 4.8,
    merchant: '斑马文具专卖店',
    stock: 800,
    weight: 0.2,
    image: 'https://readdy.ai/api/search-image?query=Zebra%20colorful%20highlighter%20pen%20set%2010%20colors%2C%20rainbow%20colors%20arranged%20in%20a%20row%2C%20clean%20white%20background%2C%20student%20stationery%20product%20photography%2C%20bright%20vivid%20colors&width=300&height=300&seq=p014&orientation=squarish',
  },
  {
    id: '15',
    name: '三菱铅笔 uni 自动铅笔套装 0.5mm 学生考试专用',
    category: 'stationery',
    price: 35.0,
    originalPrice: 52.0,
    sales: 18760,
    rating: 4.9,
    merchant: '三菱文具官方店',
    stock: 650,
    weight: 0.12,
    image: 'https://readdy.ai/api/search-image?query=Mitsubishi%20uni%20mechanical%20pencil%20set%200.5mm%20for%20students%2C%20silver%20and%20black%20design%2C%20clean%20white%20background%2C%20Japanese%20stationery%20product%20photography%2C%20exam%20pencil%20set&width=300&height=300&seq=p015&orientation=squarish',
  },
  {
    id: '16',
    name: '得力水彩笔套装 36色 儿童绘画美术专用',
    category: 'stationery',
    price: 24.9,
    originalPrice: 38.0,
    sales: 31200,
    rating: 4.7,
    merchant: '得力文具旗舰店',
    stock: 1200,
    weight: 0.35,
    image: 'https://readdy.ai/api/search-image?query=Deli%20watercolor%20pen%20set%2036%20colors%20for%20children%20art%20drawing%2C%20colorful%20markers%20in%20a%20case%2C%20clean%20white%20background%2C%20kids%20stationery%20product%20photography%2C%20rainbow%20colors&width=300&height=300&seq=p016&orientation=squarish',
  },

  // ── PAPER & NOTEBOOKS ──
  {
    id: '17',
    name: 'A4打印纸 80g 复印纸 500张/包 学生作业专用',
    category: 'paper',
    price: 28.9,
    originalPrice: 39.9,
    sales: 45670,
    rating: 4.8,
    merchant: '晨光文具旗舰店',
    stock: 3000,
    weight: 2.5,
    image: 'https://readdy.ai/api/search-image?query=A4%20white%20printing%20paper%2080gsm%20500%20sheets%20ream%2C%20clean%20white%20background%2C%20office%20stationery%20product%20photography%2C%20neat%20paper%20stack%20with%20blue%20packaging%20label&width=300&height=300&seq=p017&orientation=squarish',
  },
  {
    id: '18',
    name: '田字格练字本 小学生汉字书写专用 20本装',
    category: 'paper',
    price: 18.9,
    originalPrice: 28.0,
    sales: 27890,
    rating: 4.9,
    merchant: '学生用品专卖',
    stock: 2000,
    weight: 0.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20character%20practice%20notebook%20with%20grid%20squares%20for%20primary%20school%20students%2C%20stack%20of%2020%20notebooks%2C%20clean%20white%20background%2C%20educational%20stationery%20product%20photography%2C%20red%20cover&width=300&height=300&seq=p018&orientation=squarish',
  },
  {
    id: '19',
    name: '国誉Campus笔记本 A5 方格/横线 学生课堂记录',
    category: 'paper',
    price: 12.9,
    originalPrice: 18.0,
    sales: 56780,
    rating: 4.9,
    merchant: '国誉文具官方店',
    stock: 4000,
    weight: 0.15,
    image: 'https://readdy.ai/api/search-image?query=Kokuyo%20Campus%20notebook%20A5%20size%2C%20grid%20and%20lined%20pages%2C%20Japanese%20stationery%2C%20clean%20white%20background%2C%20minimalist%20design%2C%20student%20notebook%20product%20photography%2C%20pastel%20color%20cover&width=300&height=300&seq=p019&orientation=squarish',
  },
  {
    id: '20',
    name: '活页笔记本 B5 可拆卸 学生课堂笔记活页夹',
    category: 'paper',
    price: 32.0,
    originalPrice: 48.0,
    sales: 19340,
    rating: 4.8,
    merchant: '国誉文具官方店',
    stock: 900,
    weight: 0.4,
    image: 'https://readdy.ai/api/search-image?query=B5%20loose%20leaf%20binder%20notebook%20with%20removable%20pages%2C%20transparent%20cover%2C%20clean%20white%20background%2C%20student%20stationery%20product%20photography%2C%20organized%20ring%20binder%20with%20colorful%20dividers&width=300&height=300&seq=p020&orientation=squarish',
  },
  {
    id: '21',
    name: '牛皮纸笔记本 复古手账本 A5 学生日记创意本',
    category: 'paper',
    price: 22.0,
    originalPrice: 35.0,
    sales: 14560,
    rating: 4.7,
    merchant: '文创手账专卖',
    stock: 700,
    weight: 0.2,
    image: 'https://readdy.ai/api/search-image?query=vintage%20kraft%20paper%20notebook%20A5%20journal%20diary%2C%20retro%20brown%20cover%20with%20elastic%20band%2C%20clean%20white%20background%2C%20creative%20stationery%20product%20photography%2C%20handmade%20feel&width=300&height=300&seq=p021&orientation=squarish',
  },
  {
    id: '22',
    name: '便利贴套装 彩色便签纸 400张 学生标注备忘',
    category: 'paper',
    price: 16.9,
    originalPrice: 25.0,
    sales: 38900,
    rating: 4.8,
    merchant: '晨光文具旗舰店',
    stock: 2500,
    weight: 0.18,
    image: 'https://readdy.ai/api/search-image?query=colorful%20sticky%20notes%20set%20400%20sheets%2C%20rainbow%20pastel%20colors%2C%20clean%20white%20background%2C%20office%20stationery%20product%20photography%2C%20neat%20stack%20of%20sticky%20note%20pads&width=300&height=300&seq=p022&orientation=squarish',
  },
  {
    id: '23',
    name: '错题本 学生专用纠错本 B5 数学英语语文分科',
    category: 'paper',
    price: 19.9,
    originalPrice: 29.9,
    sales: 22100,
    rating: 4.9,
    merchant: '学生用品专卖',
    stock: 1500,
    weight: 0.25,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20student%20mistake%20correction%20notebook%20B5%2C%20subject%20dividers%20for%20math%20English%20Chinese%2C%20clean%20white%20background%2C%20educational%20stationery%20product%20photography%2C%20organized%20study%20notebook&width=300&height=300&seq=p023&orientation=squarish',
  },
  {
    id: '24',
    name: '素描本 A4 专业绘画本 120g厚纸 美术生专用',
    category: 'paper',
    price: 26.0,
    originalPrice: 38.0,
    sales: 11230,
    rating: 4.8,
    merchant: '美术用品专卖',
    stock: 600,
    weight: 0.5,
    image: 'https://readdy.ai/api/search-image?query=A4%20sketch%20drawing%20book%20120gsm%20thick%20paper%20for%20art%20students%2C%20spiral%20bound%2C%20clean%20white%20background%2C%20art%20supplies%20product%20photography%2C%20professional%20sketchbook&width=300&height=300&seq=p024&orientation=squarish',
  },

  // ── CLOTHING ──
  {
    id: '5',
    name: '儿童校服套装（春秋款）男女通用 纯棉透气',
    category: 'clothing',
    price: 89.0,
    originalPrice: 129.0,
    sales: 5670,
    rating: 4.7,
    merchant: '童装优选馆',
    stock: 600,
    weight: 0.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20children%20school%20uniform%20set%20spring%20autumn%20style%2C%20navy%20blue%20and%20white%2C%20clean%20white%20background%2C%20product%20photography%2C%20neat%20and%20tidy%2C%20cotton%20fabric%2C%20primary%20school%20uniform&width=300&height=300&seq=p003&orientation=squarish',
  },
  {
    id: '6',
    name: '中学生运动校服套装 夏季速干透气款',
    category: 'clothing',
    price: 119.0,
    originalPrice: 169.0,
    sales: 4320,
    rating: 4.8,
    merchant: '童装优选馆',
    stock: 400,
    weight: 0.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20school%20student%20sports%20uniform%20set%20summer%20style%2C%20light%20blue%20and%20white%20tracksuit%2C%20clean%20white%20background%2C%20product%20photography%2C%20breathable%20quick-dry%20fabric&width=300&height=300&seq=p010&orientation=squarish',
  },
  {
    id: '25',
    name: '小学生冬季棉服校服 加厚保暖 男女同款',
    category: 'clothing',
    price: 149.0,
    originalPrice: 219.0,
    sales: 6780,
    rating: 4.8,
    merchant: '童装优选馆',
    stock: 500,
    weight: 0.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20primary%20school%20children%20winter%20padded%20jacket%20uniform%2C%20thick%20warm%20cotton%20coat%2C%20navy%20blue%2C%20clean%20white%20background%2C%20kids%20clothing%20product%20photography%2C%20school%20uniform%20winter%20style&width=300&height=300&seq=p025&orientation=squarish',
  },
  {
    id: '26',
    name: '学生纯棉白衬衫 男女通用 正装礼仪服',
    category: 'clothing',
    price: 59.0,
    originalPrice: 89.0,
    sales: 8900,
    rating: 4.7,
    merchant: '校服工厂直营',
    stock: 800,
    weight: 0.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20student%20white%20cotton%20dress%20shirt%20formal%20uniform%2C%20clean%20white%20background%2C%20clothing%20product%20photography%2C%20neat%20collar%2C%20school%20formal%20wear%2C%20crisp%20white%20shirt&width=300&height=300&seq=p026&orientation=squarish',
  },
  {
    id: '27',
    name: '儿童运动鞋 学生跑步鞋 轻便防滑耐磨',
    category: 'clothing',
    price: 99.0,
    originalPrice: 149.0,
    sales: 12300,
    rating: 4.8,
    merchant: '童装优选馆',
    stock: 700,
    weight: 0.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20children%20student%20running%20sports%20shoes%2C%20lightweight%20non-slip%2C%20white%20and%20blue%20color%2C%20clean%20white%20background%2C%20kids%20footwear%20product%20photography%2C%20school%20sports%20shoes&width=300&height=300&seq=p027&orientation=squarish',
  },
  {
    id: '7',
    name: '儿童书包减负护脊双肩包 防水耐磨',
    category: 'clothing',
    price: 159.0,
    originalPrice: 239.0,
    sales: 9870,
    rating: 4.9,
    merchant: '童装优选馆',
    stock: 350,
    weight: 0.7,
    image: 'https://readdy.ai/api/search-image?query=colorful%20ergonomic%20children%20school%20backpack%20with%20spine%20protection%2C%20waterproof%20material%2C%20clean%20white%20background%2C%20product%20photography%2C%20cute%20cartoon%20design%2C%20multiple%20compartments&width=300&height=300&seq=p006&orientation=squarish',
  },
  {
    id: '28',
    name: '学生运动短裤 夏季速干透气 男女款',
    category: 'clothing',
    price: 39.0,
    originalPrice: 59.0,
    sales: 15600,
    rating: 4.7,
    merchant: '校服工厂直营',
    stock: 1000,
    weight: 0.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20student%20sports%20shorts%20summer%20quick-dry%20breathable%2C%20navy%20blue%2C%20clean%20white%20background%2C%20clothing%20product%20photography%2C%20school%20PE%20shorts%2C%20comfortable%20athletic%20wear&width=300&height=300&seq=p028&orientation=squarish',
  },
  {
    id: '29',
    name: '儿童针织毛衣 学生秋冬保暖套头衫',
    category: 'clothing',
    price: 79.0,
    originalPrice: 119.0,
    sales: 7430,
    rating: 4.8,
    merchant: '童装优选馆',
    stock: 450,
    weight: 0.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20children%20knitted%20sweater%20pullover%20for%20students%2C%20autumn%20winter%20warm%2C%20navy%20blue%20with%20white%20collar%2C%20clean%20white%20background%2C%20kids%20clothing%20product%20photography%2C%20school%20knitwear&width=300&height=300&seq=p029&orientation=squarish',
  },
  {
    id: '30',
    name: '学生帆布手提袋 补习班书袋 大容量环保袋',
    category: 'clothing',
    price: 25.0,
    originalPrice: 38.0,
    sales: 21000,
    rating: 4.6,
    merchant: '校服工厂直营',
    stock: 1500,
    weight: 0.15,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20student%20canvas%20tote%20bag%20for%20tutoring%20class%2C%20large%20capacity%20eco%20bag%2C%20clean%20white%20background%2C%20simple%20design%20with%20school%20logo%20print%2C%20product%20photography%2C%20beige%20cotton%20bag&width=300&height=300&seq=p030&orientation=squarish',
  },

  // ── EXISTING OTHERS ──
  {
    id: '3',
    name: '2025高考数学真题全解析+模拟卷套装',
    category: 'books',
    price: 45.0,
    originalPrice: 68.0,
    sales: 8920,
    rating: 4.8,
    merchant: '教育出版社官方店',
    stock: 1000,
    weight: 0.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20math%20exam%20preparation%20book%20set%20with%20practice%20papers%2C%20clean%20white%20background%2C%20educational%20textbook%20product%20photography%2C%20red%20and%20white%20cover%20design&width=300&height=300&seq=p002&orientation=squarish',
  },
  {
    id: '4',
    name: '考研英语词汇5500词 精讲版+配套练习册',
    category: 'books',
    price: 58.0,
    originalPrice: 85.0,
    sales: 15670,
    rating: 4.8,
    merchant: '考研书店',
    stock: 800,
    weight: 0.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20graduate%20entrance%20exam%20English%20vocabulary%20book%20set%20with%20workbook%2C%20clean%20white%20background%2C%20educational%20book%20product%20photography%2C%20blue%20and%20white%20cover&width=300&height=300&seq=p005&orientation=squarish',
  },
  {
    id: '8',
    name: '学生护眼台灯LED可调光 USB充电款',
    category: 'digital',
    price: 129.0,
    originalPrice: 199.0,
    sales: 23100,
    rating: 4.9,
    merchant: '护眼灯专卖店',
    stock: 700,
    weight: 0.9,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20study%20desk%20lamp%20for%20students%2C%20adjustable%20brightness%20and%20color%20temperature%2C%20USB%20charging%20port%2C%20clean%20white%20background%2C%20product%20photography%2C%20minimalist%20design&width=300&height=300&seq=p004&orientation=squarish',
  },
  {
    id: '9',
    name: '小学生铅笔盒文具盒 大容量双层',
    category: 'stationery',
    price: 19.9,
    originalPrice: 29.9,
    sales: 34560,
    rating: 5.0,
    merchant: '晨光文具旗舰店',
    stock: 1200,
    weight: 0.15,
    image: 'https://readdy.ai/api/search-image?query=cute%20Chinese%20primary%20school%20pencil%20case%20stationery%20box%2C%20double%20layer%20large%20capacity%2C%20colorful%20cartoon%20design%2C%20clean%20white%20background%2C%20product%20photography&width=300&height=300&seq=p008&orientation=squarish',
  },
  {
    id: '10',
    name: '学生专用学习桌椅套装 可升降护脊',
    category: 'desk',
    price: 599.0,
    originalPrice: 899.0,
    sales: 3450,
    rating: 4.7,
    merchant: '学习家具专卖',
    stock: 150,
    weight: 15,
    image: 'https://readdy.ai/api/search-image?query=modern%20adjustable%20height%20student%20study%20desk%20and%20chair%20set%2C%20ergonomic%20design%2C%20clean%20white%20background%2C%20furniture%20product%20photography%2C%20wood%20and%20metal%20frame&width=300&height=300&seq=p007&orientation=squarish',
  },
];

export const sellerMockData = {
  name: '晨光文具旗舰店',
  totalRevenue: 128450,
  pendingWithdraw: 23600,
  totalOrders: 1243,
  totalProducts: 18,
  recentOrders: [
    { id: 'ORD20250401001', product: '晨光多功能学生文具套装', buyer: '张**', amount: 39.9, status: 'shipped', trackingNo: 'SF1234567890', time: '2025-04-01 10:23' },
    { id: 'ORD20250401002', product: '英雄钢笔礼盒套装', buyer: '李**', amount: 68.0, status: 'delivered', trackingNo: 'YT9876543210', time: '2025-04-01 09:15' },
    { id: 'ORD20250331003', product: '晨光多功能学生文具套装', buyer: '王**', amount: 19.9, status: 'pending', trackingNo: '', time: '2025-03-31 16:40' },
    { id: 'ORD20250331004', product: '晨光多功能学生文具套装', buyer: '赵**', amount: 79.8, status: 'shipped', trackingNo: 'ZTO5566778899', time: '2025-03-31 14:22' },
    { id: 'ORD20250330005', product: '英雄钢笔礼盒套装', buyer: '陈**', amount: 136.0, status: 'delivered', trackingNo: 'JD1122334455', time: '2025-03-30 11:05' },
  ],
};
